import { render, staticRenderFns } from "./ActionableForms.vue?vue&type=template&id=3ae12964&"
import script from "./ActionableForms.vue?vue&type=script&lang=ts&"
export * from "./ActionableForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports